/*
  把合集下一页的商品接到当前列表后面。

  地址栏不改。下一页地址只用按钮上的 href，不自己累加 page。
  筛选换掉列表后，这次请求的结果直接丢掉。
  请求失败、超时或返回内容异常时，恢复按钮，让用户可以再点一次。
*/
(function () {
  if (window.collectionLoadMoreInitialized) return;
  window.collectionLoadMoreInitialized = true;

  // 连续几页都没有可见商品时停止，避免隐藏标签把请求串成死循环。
  var MAX_EMPTY_PAGES = 3;
  var REQUEST_TIMEOUT_MS = 20000;

  document.addEventListener('click', onLoadMoreClick);

  function onLoadMoreClick(event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var button = event.target.closest('[data-collection-load-more]');
    if (!button) return;

    var grid = findGrid(button);
    // 找不到当前列表时保留链接跳转，用户仍然能打开下一页。
    if (!grid) return;

    event.preventDefault();
    loadNextPage(grid, button);
  }

  function findContainer(node) {
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest('#ProductGridContainer, [data-load-more-container]');
  }

  function findGrid(button) {
    var container = findContainer(button);
    if (!container) return null;
    var grid = container.querySelector('ul[data-load-more-grid], ul#product-grid');
    if (!grid || grid.tagName !== 'UL') return null;
    return grid;
  }

  function findRenderedGrid(doc) {
    var container = doc.querySelector('#ProductGridContainer, [data-load-more-container]');
    if (!container) return null;
    return container.querySelector('[data-load-more-grid], #product-grid');
  }

  function loadTarget(button) {
    var value = parseInt(button.getAttribute('data-load-target') || '0', 10);
    return value > 0 ? value : 0;
  }

  function hasMorePages(button) {
    var href = button.getAttribute('href') || '';
    return href.indexOf('page=') !== -1;
  }

  function revealPending(grid, maxToAdd) {
    var pending = grid.querySelectorAll('[data-load-more-pending]');
    var revealed = 0;
    Array.prototype.forEach.call(pending, function (item) {
      if (revealed >= maxToAdd) return;
      item.removeAttribute('hidden');
      item.removeAttribute('data-load-more-pending');
      revealed += 1;
    });
    return revealed;
  }

  function loadNextPage(grid, button) {
    if (button.getAttribute('aria-busy') === 'true') return;

    var target = loadTarget(button);
    var revealed = target > 0 ? revealPending(grid, target) : 0;
    var pendingLeft = target > 0 && grid.querySelector('[data-load-more-pending]');

    // 页面里还有预先放好的商品时，这一次只把它们显示出来。
    if (pendingLeft) return;
    if (target > 0 && (revealed >= target || !hasMorePages(button))) {
      if (!hasMorePages(button)) removeLoadMore(button, grid);
      return;
    }

    grid.setAttribute('aria-busy', 'true');
    loadPages(grid, button, 0, revealed, 0).finally(function () {
      if (grid.isConnected) grid.removeAttribute('aria-busy');
    });
  }

  function loadPages(grid, button, emptyPages, addedSoFar, hops) {
    var requestedUrl = button.getAttribute('href');
    var controller = new AbortController();
    var target = loadTarget(button);
    if (!addedSoFar) addedSoFar = 0;
    if (!hops) hops = 0;

    if (target > 0 && hops >= 8) {
      restoreButton(button);
      return Promise.resolve();
    }

    setLoading(button, true);

    return withTimeout(fetchSectionHtml(button, controller.signal), REQUEST_TIMEOUT_MS, controller)
      .then(function (html) {
        // 筛选已经换掉原来的列表，不能把旧结果接上去。
        if (!grid.isConnected) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = findRenderedGrid(parsed);

        if (!nextGrid) {
          restoreButton(button);
          return;
        }

        if (nextGrid.tagName !== 'UL') {
          if (nextGrid.classList.contains('collection--empty')) {
            removeLoadMore(button, grid);
          } else {
            restoreButton(button);
          }
          return;
        }

        var room = target > 0 ? target - addedSoFar : 0;
        var result = appendNewProducts(grid, nextGrid, room);
        var addedCount = result.addedCount;
        var totalAdded = addedSoFar + addedCount;

        // 这一页里还有没接上的新商品，下次点击继续用同一个地址。
        if (target > 0 && result.stoppedEarly) {
          restoreButton(button);
          return;
        }

        var nextButton = swapLoadMore(button, parsed, grid);

        if (target > 0) {
          if (totalAdded >= target || !nextButton) return;
          if (nextButton.getAttribute('href') === requestedUrl) {
            restoreButton(nextButton);
            return;
          }
          return loadPages(grid, nextButton, 0, totalAdded, hops + 1);
        }

        if (addedCount > 0 || !nextButton) return;
        if (nextButton.getAttribute('href') === requestedUrl) {
          restoreButton(nextButton);
          return;
        }
        if (emptyPages + 1 >= MAX_EMPTY_PAGES) {
          restoreButton(nextButton);
          return;
        }

        return loadPages(grid, nextButton, emptyPages + 1, 0, hops + 1);
      })
      .catch(function () {
        restoreButton(button);
      });
  }

  // 到点就结束这次点击。页面上别的脚本可能包过 fetch，中止信号不一定生效。
  function withTimeout(promise, ms, controller) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        controller.abort();
        reject(new Error('Load more timed out'));
      }, ms);

      promise.then(
        function (value) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve(value);
        },
        function (error) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          reject(error);
        }
      );
    });
  }

  function fetchSectionHtml(button, signal) {
    return Promise.resolve()
      .then(function () {
        var nextUrl = button.getAttribute('href');
        var sectionId = button.getAttribute('data-section-id');
        if (!nextUrl || !sectionId) throw new Error('Missing load more target');

        var url = new URL(nextUrl, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Unexpected load more url');

        url.searchParams.set('section_id', sectionId);
        return fetch(url.toString(), {
          cache: 'no-store',
          credentials: 'same-origin',
          signal: signal
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Load more request failed');
        return response.text();
      });
  }

  function appendNewProducts(grid, nextGrid, maxToAdd) {
    var seenIds = {};
    Array.prototype.forEach.call(grid.querySelectorAll('[data-product-id]'), function (item) {
      var productId = item.getAttribute('data-product-id');
      if (productId) seenIds[productId] = true;
    });

    var addedCount = 0;
    var stoppedEarly = false;
    Array.prototype.forEach.call(nextGrid.children, function (item) {
      if (stoppedEarly || item.tagName !== 'LI') return;

      var productId = item.getAttribute('data-product-id');
      if (productId && seenIds[productId]) return;
      if (maxToAdd > 0 && addedCount >= maxToAdd) {
        stoppedEarly = true;
        return;
      }
      if (productId) seenIds[productId] = true;

      var imported = document.importNode(item, true);
      imported.removeAttribute('hidden');
      imported.removeAttribute('data-load-more-pending');
      grid.appendChild(imported);
      addedCount += 1;
    });

    return { addedCount: addedCount, stoppedEarly: stoppedEarly };
  }

  function swapLoadMore(currentButton, parsedDocument, grid) {
    var root = currentButton.closest('.collection-load-more');
    if (!root) return null;

    var nextRoot = parsedDocument.querySelector('.collection-load-more');
    var keepFocus = isFocusedWithin(currentButton);

    if (!nextRoot) {
      if (keepFocus) focusWithoutScrolling(grid);
      root.remove();
      return null;
    }

    var imported = document.importNode(nextRoot, true);
    var nextButton = imported.querySelector('[data-collection-load-more]');
    root.replaceWith(imported);
    if (keepFocus) focusWithoutScrolling(nextButton || grid);
    return nextButton;
  }

  function removeLoadMore(button, grid) {
    var root = button.closest('.collection-load-more');
    if (!root) return;
    if (isFocusedWithin(button)) focusWithoutScrolling(grid);
    root.remove();
  }

  function restoreButton(button) {
    if (!button || !button.isConnected) return;
    setLoading(button, false);
  }

  function setLoading(button, isLoading) {
    if (!button) return;

    var label = button.getAttribute(isLoading ? 'data-loading-label' : 'data-label');
    if (label) button.textContent = label;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  }

  function isFocusedWithin(element) {
    var active = document.activeElement;
    return active === element || (!!element && element.contains(active));
  }

  function focusWithoutScrolling(element) {
    if (!element || typeof element.focus !== 'function') return;
    if (element.tagName === 'UL') element.setAttribute('tabindex', '-1');
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }
})();
